import { render, staticRenderFns } from "./EvidenceList.vue?vue&type=template&id=95e1c002&scoped=true&"
import script from "./EvidenceList.vue?vue&type=script&lang=js&"
export * from "./EvidenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e1c002",
  null
  
)

export default component.exports